export default __webpack_public_path__ + "static/media/munc.7fc7a793.svg";